export default {
  currentUser: {
    id: '',
    role: '',
    name: '',
    email: ''
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/userState.js